import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';

const PanelTooltip = observer(({text}) => {
  return (
    <span>
      <i className='material-icons h4 align-middle jumbo PanelTooltip ml1'
        data-tooltip-text={t(text)}>{'info_outline'}</i>
      <div className='PanelTooltip-box'></div>
    </span>
  );
});

const PanelTooltipWithComponent = observer(({children}) => {
  return (
    <span>
      <i className='material-icons h4 align-middle jumbo PanelTooltip ml1'>
        {'info_outline'}
      </i>
      <div className='PanelTooltipContent'>
        {children}
      </div>
      <div className='PanelTooltip-box'></div>
    </span>
  );
});

const PanelTooltipFactory = observer(({text, children}) => {
  if (React.Children.count(children) > 0) {
    return <PanelTooltipWithComponent>{children}</PanelTooltipWithComponent>;
  }

  return <PanelTooltip text={text}/>;
});

export default PanelTooltipFactory;
